'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import Drawer from '@mui/material/Drawer';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { ROUTES } from 'src/constants/routes';
import { CHROME_HEIGHTS } from 'src/constants/styles';
import useRouteWithParams from 'src/hooks/useRouteWithParams';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import { Image } from 'src/components/Atoms/Image';
import { Skeleton } from 'src/components/Atoms/Skeleton';
import Button from '@mui/material/Button';
import { Close } from 'src/components/Molecules/Close';
import useTranslations from 'src/hooks/useTranslations';
interface GoalsProps {
  loading: boolean;
}
;
const GoalsWrapper = styled(FlexRow)(() => ({
  position: 'absolute',
  alignItems: 'center',
  right: 0,
  height: '2.5rem',
  alignSelf: 'stretch'
}));
const GoalsDrawer = styled(Drawer)(() => ({
  width: '53rem',
  '& .MuiDrawer-paper': {
    paddingTop: `${CHROME_HEIGHTS.topBar}rem`

    // top: '5rem',
    // right: '1rem',
    // height: 'auto',
    // maxHeight: 'calc(100vh - 7rem)',
  }
}));
const GoalsHeader = styled(FlexColumn)(({
  theme
}) => ({
  padding: theme.sizes.spacing['08'],
  position: 'relative',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  width: '53rem',
  backgroundColor: theme.colors.surface.primary,
  borderBottom: `1px solid ${theme.colors.border.secondary}`
}));
const GoalsContent = styled(FlexColumn)(({
  theme
}) => ({
  padding: theme.sizes.spacing['08'],
  gap: theme.sizes.spacing['07'],
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  height: '100%',
  width: '53rem',
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.colors.surface.tertiary} transparent`,
  '&::-webkit-scrollbar': {
    display: 'block',
    width: '0.375rem',
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-track': {
    // background: theme.colors.surface.brand,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: theme.sizes.radius.full
    // backgroundColor: theme.colors.border.hover,
  }
}));
const GoalsFooter = styled(FlexColumn)(({
  theme
}) => ({
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  alignSelf: 'stretch',
  width: '53rem',
  padding: `${theme.sizes.spacing['07']} ${theme.sizes.spacing['07']} ${theme.sizes.spacing['07']} ${theme.sizes.spacing['09']}`,
  backgroundColor: theme.colors.surface.secondary,
  borderBottom: `1px solid ${theme.colors.border.secondary}`
}));
const SeparatorLine = styled(FlexColumn)(({
  theme
}) => ({
  width: '100%',
  alignSelf: 'stretch',
  padding: '0.5px',
  height: '0px',
  border: 'none',
  backgroundColor: theme.colors.border.primary
}));
const Segment = styled(FlexRow)(({
  theme
}) => ({
  width: '100%',
  height: 'auto',
  gap: theme.sizes.spacing['07'],
  padding: `${theme.sizes.spacing.none} ${theme.sizes.spacing.none} ${theme.sizes.spacing['07']}`,
  alignItems: 'flex-start',
  '& .MuiTypography-body-sm': {
    color: theme.colors.text.secondary
  }
}));
const ButtonWrapper = styled(FlexRow)(({
  theme
}) => ({
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  height: '100%',
  gap: theme.sizes.spacing['03']
}));
const Paragraph = styled(FlexColumn)(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  gap: theme.sizes.spacing['07'],
  flex: '1 0 0'
}));
const CloseWrapper = styled(FlexColumn)(({
  theme
}) => ({
  position: 'absolute',
  top: theme.sizes.spacing['04'],
  right: theme.sizes.spacing['04'],
  zIndex: 1000,
  color: theme.colors.text.primary,
  backgroundColor: theme.colors.surface.primary,
  '&:hover': {
    backgroundColor: theme.colors.surface.secondary
  }
}));
const Goals: React.FC<GoalsProps> = t0 => {
  const $ = _c(86);
  const {
    loading
  } = t0;
  const {
    t
  } = useTranslations();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const router = useRouter();
  const {
    updatePathWithParams
  } = useRouteWithParams();
  let t1;
  if ($[0] !== updatePathWithParams) {
    t1 = updatePathWithParams(ROUTES.BOOK_A_MEETING);
    $[0] = updatePathWithParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const bookAMeetingRoute = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsDrawerOpen(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleDrawer = t2;
  let t3;
  if ($[3] !== loading || $[4] !== t) {
    t3 = <GoalsWrapper>{loading ? <Skeleton width="5rem" height="2.5rem" /> : <Button variant="outlined" onClick={toggleDrawer}>{t("components.goals.buttonText")}</Button>}</GoalsWrapper>;
    $[3] = loading;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsDrawerOpen(false);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("components.goals.setTargets");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Typography variant="heading-lg">{t5}</Typography>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CloseWrapper><Close icon={true} onClick={() => setIsDrawerOpen(false)} /></CloseWrapper>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <GoalsHeader>{t6}{t7}</GoalsHeader>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      whiteSpace: "pre-wrap"
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("components.goals.goalsDescription");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <Typography variant="body3" sx={t9}>{t10}</Typography>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== bookAMeetingRoute || $[20] !== router) {
    t12 = () => router.push(bookAMeetingRoute);
    $[19] = bookAMeetingRoute;
    $[20] = router;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t("common.bookMeeting");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <ButtonWrapper><Button onClick={t12}>{t13}</Button></ButtonWrapper>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t11 || $[28] !== t14) {
    t15 = <Segment><Paragraph>{t11}{t14}</Paragraph></Segment>;
    $[27] = t11;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Image src="/images/bullet_ad_spend.png" width={64} height={64} alt="ad spend" />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t("components.goals.adSpendTitle");
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17) {
    t18 = <Typography variant="h5">{t17}</Typography>;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      whiteSpace: "pre-wrap"
    };
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t) {
    t20 = t("components.goals.adSpendDescription");
    $[36] = t;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t20) {
    t21 = <Typography variant="body-sm" sx={t19}>{t20}</Typography>;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t21) {
    t22 = <Segment>{t16}<Paragraph>{t18}{t21}</Paragraph></Segment>;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <SeparatorLine />;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Image src="/images/bullet_revenue.png" width={64} height={64} alt="ad spend" />;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t) {
    t25 = t("components.goals.revenueTitle");
    $[45] = t;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t25) {
    t26 = <Typography variant="h5">{t25}</Typography>;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      whiteSpace: "pre-wrap"
    };
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t) {
    t28 = t("components.goals.revenueDescription");
    $[50] = t;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t28) {
    t29 = <Typography variant="body-sm" sx={t27}>{t28}</Typography>;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t26 || $[55] !== t29) {
    t30 = <Segment>{t24}<Paragraph>{t26}{t29}</Paragraph></Segment>;
    $[54] = t26;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SeparatorLine />;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Image src="/images/bullet_visitors.png" width={64} height={64} alt="ad spend" />;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t) {
    t33 = t("components.goals.visitorsTitle");
    $[59] = t;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== t33) {
    t34 = <Typography variant="h5">{t33}</Typography>;
    $[61] = t33;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      whiteSpace: "pre-wrap"
    };
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t) {
    t36 = t("components.goals.visitorsDescription");
    $[64] = t;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== t36) {
    t37 = <Typography variant="body-sm" sx={t35}>{t36}</Typography>;
    $[66] = t36;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] !== t34 || $[69] !== t37) {
    t38 = <Segment>{t32}<Paragraph>{t34}{t37}</Paragraph></Segment>;
    $[68] = t34;
    $[69] = t37;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== t15 || $[72] !== t22 || $[73] !== t30 || $[74] !== t38) {
    t39 = <GoalsContent>{t15}{t22}{t23}{t30}{t31}{t38}</GoalsContent>;
    $[71] = t15;
    $[72] = t22;
    $[73] = t30;
    $[74] = t38;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <GoalsFooter><Close variant="text" onClick={() => setIsDrawerOpen(false)} /></GoalsFooter>;
    $[76] = t40;
  } else {
    t40 = $[76];
  }
  let t41;
  if ($[77] !== t39 || $[78] !== t8) {
    t41 = <>{t8}{t39}{t40}</>;
    $[77] = t39;
    $[78] = t8;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  if ($[80] !== isDrawerOpen || $[81] !== t41) {
    t42 = <GoalsDrawer anchor="right" open={isDrawerOpen} onClose={t4}>{t41}</GoalsDrawer>;
    $[80] = isDrawerOpen;
    $[81] = t41;
    $[82] = t42;
  } else {
    t42 = $[82];
  }
  let t43;
  if ($[83] !== t3 || $[84] !== t42) {
    t43 = <>{t3}{t42}</>;
    $[83] = t3;
    $[84] = t42;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  return t43;
};
export default Goals;
export type { GoalsProps };